import { bezier } from './create-bezier'

import {
  useControls,
} from "leva";

export function BezierWrapper() {

    const myCurve = useControls({ curveObj: bezier()})
    return (
    <pre>
    </pre>
  )
}